/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React from "react"
import { Container, Stack, Text } from "@carrotfertility/carotene"
import { ArrowLink } from "../../../../components/views/atoms/links/ArrowLink"
import { Spacer } from "../../../../components/views/atoms/Atoms"
import { FormattedMessage } from "react-intl"

type TierInfoProps = {
  showLink?: boolean
}

export function TierInfoWhenCustomNetworksForSidebar({ showLink }: TierInfoProps): JSX.Element {
  return (
    <Container background="white" borderRadius="8px" padding="medium">
      <Stack spacing="tiny">
        <Text font="gotham" weight="bold">
          <FormattedMessage defaultMessage={`What are provider tiers?`} />
        </Text>
        <Text font="gotham" size="small">
          <FormattedMessage
            defaultMessage={`Your health insurance plan offers two in-network provider tiers for fertility clinics: Tier 1 and Tier 2.`}
          />
          <Spacer height={1} />
          <FormattedMessage
            defaultMessage={`Your chosen provider’s tier impacts your deductibles and how you pay for care.`}
          />
        </Text>
        {showLink ? (
          <ArrowLink to="/your-benefit-guide/coverage/employer-specific-information">
            <FormattedMessage defaultMessage={`Learn more`} />
          </ArrowLink>
        ) : null}
      </Stack>
    </Container>
  )
}
